import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import "./App.css";
import HomeScreen from "./screens/HomeScreen";
import OfferListScreens from "./screens/OfferListScreens";
import OfferDetails from "./screens/OfferDetails";
import ShopDashboardScreen from "./screens/AdminScreens/ShopDashboardScreen";
import ShopOfferCreateScreen from "./screens/AdminScreens/ShopOfferCreateScreen";
import LoginScreen from "./screens/AdminScreens/LoginScreen";
import ShopRegister from "./screens/AdminScreens/ShopRegister";
import "leaflet/dist/leaflet.css";
import { SideBarComp } from "./components/SideBarComp";
import ContactSupport from "./screens/ContactSupport";
import Header from "./components/Header";

function App() {
	const navigate = useNavigate();
	const location = useLocation();
	return (
		<div className="App">
			<header>
				<div className="d-flex justify-content-between px-3 py-3">
					<div>
						<Header title="Near By Offers" />
						{/* <img
							src="/images/logoImage/logo.jpeg"
							alt="Near By Deals"
						/> */}
					</div>
					<div>
						<SideBarComp />
					</div>
				</div>

				{location.pathname !== "/" && (
					<div
						onClick={() => navigate(-1)}
						className="d-flex align-items-center px-3 pb-3 back-btn"
					>
						<i className="fas fa-arrow-left pr-2"></i>
						<h6 className="m-0">back </h6>
					</div>
				)}
			</header>

			<main>
				<Routes>
					<Route path="/" element={<HomeScreen />} />
					<Route
						path="/contact-support"
						element={<ContactSupport />}
					/>
					<Route path="/offer-list" element={<OfferListScreens />} />
					<Route path="/offer-details" element={<OfferDetails />} />
					<Route
						path="/shop-dashboard"
						element={<ShopDashboardScreen />}
					/>
					<Route
						path="/offer-create-form"
						element={<ShopOfferCreateScreen />}
					/>
					<Route path="/login-screen" element={<LoginScreen />} />
					<Route path="/register-screen" element={<ShopRegister />} />
				</Routes>
			</main>
			<footer>
				<div>All rights reserved ©2026</div>
			</footer>
		</div>
	);
}

export default App;
